import React, { useEffect, useState, useRef } from "react";
import { Button, Image, Table, Tabs } from 'antd';
import axios from "axios";
import { API_BASE_URL } from '../../const/const';
import { CloseCircleOutlined } from '@ant-design/icons';
import { LoadingOutlined } from '@ant-design/icons';
import { LoadingMsg } from "../mensagens-alertas/loading";
import { AlertaMsg } from "../mensagens-alertas/mensagemdealerta";
import { ErroMsg } from "../mensagens-alertas/mensagemdeerro";
import { SucessoMsg } from "../mensagens-alertas/mensagemdesucesso";
import { PesoMsg } from "../mensagens-alertas/mensagemdepeso";
import { isAppNativa, isCancelamento, tirarFoto, escolherFotosDaGaleria, escolherVideosDaGaleria } from './media-nativa';
import { iniciarEnvio, registarLote, terminarEnvio, cabecalhosAuditoria } from './auditoria-upload';
// import { Spin } from 'antd';
// import { BiError } from "react-icons/bi";
// import { fabClasses } from "@mui/material";
// import { TramOutlined } from "@mui/icons-material";

const antIcon = (
    <LoadingOutlined
        style={{
            fontSize: 30,
        }}
        spin
    />
);



const AreaGestaoReservaAdmin = ({
    videoooos,
    fotografiassss,
    idDaReservaPost,
    dadodareserva,
    isTabletMobile,
    localdeestacionamentodata,
    id,
    cancelamentodareserva,
    userMain,
    logsData,
    setLogsData,
    setDataReserva
}) => {


    // console.log(fotografiassss)


    //obter dados do funionario
    const userFromLocalStorage = localStorage.getItem('user');
    const userRole = userMain?.roles[0]
    const userNameAccount = userMain?.data.user_nicename
    const dadosdofuncionarioparalogs = userMain?.data



    //Local de Estaciomento
    const [historicolocaldeestacionamento, setHistoricoLocaldeEstacionamento] = useState(''); //historico atualizado
    const [localdeestacionamentoenviado, setlocaldeestacionamentoenviado] = useState(false); //para validar se o local de estacionamento foi enviado
    //loadings dLocal de Estaciomento
    const [isLoadingLocalEstacionamento, setIsLoadingLocalEstacionamento] = useState(false);
    const [isSucessoLocalEstacionamento, setIsSucessoLocalEstacionamentoa] = useState(false);
    const [isAlertaLocalEstacionamento, setIsAlertaLocalEstacionamento] = useState(false);
    const [isFalhaLocalEstacionamento, setIsFalhaLocalEstacionamento] = useState(false);



    //Imagens
    const [selectedFile, setSelectedFile] = useState(''); //ficheiros
    const [conjuntodeimagensids, setConjuntodeimagensids] = useState([]); //conjunto de imagens - ids
    const [conjuntodeimagens, setConjuntodeimagens] = useState([]); //conjunto de imagens - url
    //Imagens-LOADING
    const [isLoadingFotos, setIsLoadingFotos] = useState(false); //loading fotos
    const [isFalhaFotos, setIsFalhaFotos] = useState(false); //falha fotos
    const [isSucessoFotos, setIsSucessoFotos] = useState(false);
    const [isAlertaFotos, setIsAlertaFotos] = useState(false);
    const [mensagemErroFotos, setMensagemErroFotos] = useState('');



    //Videos
    const [selectedFilevideo, setSelectedFilevideo] = useState(''); //ficheiros
    const [conjuntodevideo, setConjuntodevideo] = useState([]); //conjunto de imagens - url
    const [conjuntodevideoids, setConjuntodevideoids] = useState([]); //conjunto de imagens - ids
    //Videos-LOADING
    const [isLoadingVideos, setIsLoadingVideos] = useState(false);
    const [isSucessoVideos, setIsSucessoVideos] = useState(false);
    const [isAlertaVideos, setIsAlertaVideos] = useState(false);
    const [mensagemErroVideos, setMensagemErroVideos] = useState('');
    const [isFalhaVideos, setIsFalhaVideos] = useState(false);
    const [isPesodeCarregamentoVideos, setIsPesodeCarregamentoVideos] = useState(false);




    const inputRef = useRef(null);
    const inputRefVideos = useRef(null);


    useEffect(() => {
        if (fotografiassss && fotografiassss.length > 0 && conjuntodeimagens.length === 0) {

            const imageUrls = fotografiassss.map((foto) => foto.url);
            const arr_ids_fotos = fotografiassss.map((foto) => foto.id);

            setConjuntodeimagensids(arr_ids_fotos);
            setConjuntodeimagens(imageUrls);

            // console.log('arr_ids_fotos', arr_ids_fotos)
            // console.log('imageUrls', imageUrls)
        }
    }, [fotografiassss, conjuntodeimagens]);


    useEffect(() => {
        if (videoooos && videoooos.length > 0 && conjuntodevideo.length === 0) {

            const videoUrls = videoooos?.map((video) => video.url);
            const arr_ids_video = videoooos?.map((video) => video.id);

            setConjuntodevideoids(arr_ids_video)
            setConjuntodevideo(videoUrls);
        }
    }, [videoooos, conjuntodevideo]);



    //OBTER LOGS DA RESERVA
    // console.log(idDaReservaPost)
    useEffect(() => {

        if(idDaReservaPost !== undefined){
            axios
                .get(`${API_BASE_URL}/api/get_logs/${idDaReservaPost}?timestamp=${new Date().getTime()}`)
                .then((response) => {
                    // console.log(response)

                    const alllogsData = response.data.map((novadata) => {

                        const dataEmPartes = novadata.date.split(' ');
                        const dataPartes = dataEmPartes[0].split('-');
                        const horaPartes = dataEmPartes[1].split(':');
                        const diaHistorico = dataPartes[2];
                        const mesHistorico = dataPartes[1];
                        const anoHistorico = dataPartes[0];
                        const hora = horaPartes[0];
                        const minutos = horaPartes[1];
                        const segundos = horaPartes[2];

                        const formattedDate = `${diaHistorico}/${mesHistorico}/${anoHistorico} ${hora}:${minutos}:${segundos}`;

                        return {
                            ...novadata,
                            formattedDate,
                        };
                    });

                    // console.log(alllogsData)

                    setLogsData(alllogsData);
                    // console.log('logs', logsData, '', idDaReservaPost)
                })
                .catch((error) => {
                    console.error('Erro:', error);
                });
        }

    }, [dadodareserva]);


    //IMAGENS VIATURAS   ---------------

    // Limite do original antes da compressão (fotos de telemóvel têm até ~25MB; depois de comprimidas ficam com ~150-300KB)
    const MAX_FILE_SIZE_MB = 50;
    const LADO_MAX_PX = 1600;
    const QUALIDADE_JPEG = 0.7;
    // O App Engine recusa pedidos acima de 32MB: cada vídeo vai num pedido próprio e não pode passar este limite
    const MAX_VIDEO_SIZE_MB = 30;
    // O BFF aceita até 30 ficheiros por pedido
    const FOTOS_POR_PEDIDO = 10;

    const mensagemErroUpload = (error) => {
        if (error.response?.status === 413) return 'ficheiro demasiado grande ou ficheiros a mais.';
        if (error.response) return 'tente novamente.';
        return `${error.message}.`;
    };

    const handleFileInputChange = (e) => {
        const files = e.target.files;
        const oversized = Array.from(files).filter(f => f.size > MAX_FILE_SIZE_MB * 1024 * 1024);
        if (oversized.length > 0) {
            setIsAlertaFotos(true);
            setSelectedFile('');
            if (inputRef.current) inputRef.current.value = '';
            return;
        }
        setIsAlertaFotos(false);
        setSelectedFile(files);
    };

    // Redimensiona e comprime para JPEG no browser. Rejeita (em vez de ficar pendurado) se o browser não conseguir ler a imagem (ex.: HEIC fora do Safari)
    // info (opcional) recebe as dimensões originais, para a auditoria
    const comprimirImagem = (file, info = {}) => new Promise((resolve, reject) => {
        if (file.size > MAX_FILE_SIZE_MB * 1024 * 1024) {
            reject(new Error(`Ficheiro "${file.name}" excede ${MAX_FILE_SIZE_MB}MB`));
            return;
        }
        const url = URL.createObjectURL(file);
        // window.Image: neste ficheiro "Image" é o componente do antd
        const img = new window.Image();
        img.onload = () => {
            URL.revokeObjectURL(url);
            info.largura = img.naturalWidth;
            info.altura = img.naturalHeight;
            const escala = Math.min(1, LADO_MAX_PX / Math.max(img.naturalWidth, img.naturalHeight));
            const canvas = document.createElement('canvas');
            canvas.width = Math.round(img.naturalWidth * escala);
            canvas.height = Math.round(img.naturalHeight * escala);
            const ctx = canvas.getContext('2d');
            // Fundo branco: PNG com transparência ficaria preto em JPEG
            ctx.fillStyle = '#fff';
            ctx.fillRect(0, 0, canvas.width, canvas.height);
            ctx.imageSmoothingQuality = 'high';
            ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
            canvas.toBlob((blob) => {
                if (!blob) {
                    reject(new Error(`Não foi possível comprimir "${file.name}"`));
                    return;
                }
                const nome = file.name.replace(/\.[^.]*$/, '') + '.jpg';
                resolve(new File([blob], nome, { type: 'image/jpeg' }));
            }, 'image/jpeg', QUALIDADE_JPEG);
        };
        img.onerror = () => {
            URL.revokeObjectURL(url);
            reject(new Error(`Não foi possível ler a imagem "${file.name}"`));
        };
        img.src = url;
    });


    // App nativa: cada tiragem/selecção acrescenta à lista por enviar
    const acrescentarFotos = (novas) => {
        setIsAlertaFotos(false);
        setIsFalhaFotos(false);
        setSelectedFile(prev => [...Array.from(prev || []), ...novas]);
    };

    const handleTirarFoto = async () => {
        try {
            acrescentarFotos([await tirarFoto()]);
        } catch (error) {
            if (!isCancelamento(error)) {
                setMensagemErroFotos(`${error.message}.`);
                setIsFalhaFotos(true);
            }
        }
    };

    const handleEscolherFotosGaleria = async () => {
        try {
            acrescentarFotos(await escolherFotosDaGaleria());
        } catch (error) {
            if (!isCancelamento(error)) {
                setMensagemErroFotos(`${error.message}.`);
                setIsFalhaFotos(true);
            }
        }
    };

    const handleEscolherVideosGaleria = async () => {
        try {
            const videos = await escolherVideosDaGaleria();
            if (videos.some(video => video.size > MAX_VIDEO_SIZE_MB * 1024 * 1024)) {
                setIsAlertaVideos(true);
                return;
            }
            setIsAlertaVideos(false);
            setIsFalhaVideos(false);
            setSelectedFilevideo(prev => [...Array.from(prev || []), ...videos]);
        } catch (error) {
            if (!isCancelamento(error)) {
                setMensagemErroVideos(`${error.message}.`);
                setIsFalhaVideos(true);
            }
        }
    };

    // Envia um lote e regista na auditoria o tempo do pedido, o resultado e os tempos que o servidor devolve
    const enviarLoteAuditado = async (auditoria, indice, ficheiros, pedido) => {
        const lote = {
            lote: indice,
            nFicheiros: ficheiros.length,
            bytes: ficheiros.reduce((total, f) => total + f.size, 0),
            inicio: new Date().toISOString(),
        };
        const t0 = performance.now();
        try {
            const resposta = await pedido();
            lote.status = resposta.status;
            lote.mediaIds = resposta.data.mediaIds;
            lote.servidor = resposta.data.auditoria;
            return resposta;
        } catch (error) {
            lote.status = error.response?.status || 0;
            lote.erro = error.response?.data?.message || error.message;
            throw error;
        } finally {
            lote.msPedido = Math.round(performance.now() - t0);
            registarLote(auditoria, lote);
        }
    };

    const handleEnviarFotos = async () => {

        if (selectedFile.length < 1) {
            setIsAlertaFotos(true)
            setIsLoadingFotos(false);
            setIsSucessoFotos(false);
            setIsFalhaFotos(false);

            return;

        } else {

            setIsAlertaFotos(false)
            setIsLoadingFotos(true);
            setIsSucessoFotos(false);
            setIsFalhaFotos(false);
            setMensagemErroFotos('');

            const auditoria = iniciarEnvio('fotos', idDaReservaPost, selectedFile);
            try {
                // Comprimir uma a uma: em telemóvel, descodificar várias fotos grandes em paralelo pode esgotar a memória
                const files = Array.from(selectedFile);
                const resizedFiles = [];
                for (const [indice, file] of files.entries()) {
                    const registo = auditoria.ficheiros[indice];
                    const inicioCompressao = performance.now();
                    try {
                        // Sempre comprimidas aqui: a selecção múltipla nativa (Android) devolve os originais sem redimensionar
                        resizedFiles.push(await comprimirImagem(file, registo));
                    } catch (error) {
                        registo.erro = error.message;
                        throw error;
                    } finally {
                        registo.msCompressao = Math.round(performance.now() - inicioCompressao);
                    }
                    registo.bytesComprimido = resizedFiles[resizedFiles.length - 1].size;
                }

                // Enviar em lotes; o BFF junta os novos IDs à galeria que a reserva já tem no WP
                let allIds = [...conjuntodeimagensids];
                for (let i = 0; i < resizedFiles.length; i += FOTOS_POR_PEDIDO) {
                    const formData = new FormData();
                    const lote = resizedFiles.slice(i, i + FOTOS_POR_PEDIDO);
                    lote.forEach(file => formData.append('files', file));

                    const uploadResponse = await enviarLoteAuditado(auditoria, i / FOTOS_POR_PEDIDO, lote, () => axios.post(
                        `/proxy-media/upload-photos/${idDaReservaPost}`,
                        formData,
                        { headers: { 'Content-Type': 'multipart/form-data', ...cabecalhosAuditoria(auditoria, i / FOTOS_POR_PEDIDO) } }
                    ));

                    allIds = [...allIds, ...uploadResponse.data.mediaIds];
                    setConjuntodeimagensids(allIds);
                    uploadResponse.data.mediaUrls.forEach(url => conjuntodeimagens.push(url));
                    setConjuntodeimagens([...conjuntodeimagens]);
                    // O que já subiu sai da selecção, para uma nova tentativa não duplicar
                    setSelectedFile(files.slice(i + FOTOS_POR_PEDIDO));
                }
                setSelectedFile([]);
                terminarEnvio(auditoria);


                    if (inputRef.current) {
                        inputRef.current.value = '';
                    }


                    let enviarlogsdata;

                    enviarlogsdata = {
                        id_reserva: idDaReservaPost,
                        description: `Adicionou imagens à reserva`,
                        tipo: "upload",
                        user_id: dadosdofuncionarioparalogs.ID,
                        user_name: dadosdofuncionarioparalogs.display_name,
                    };

                    axios
                        .post(`${API_BASE_URL}/api/post_log`, enviarlogsdata)
                        .then(response => {
                            // console.log(response)
                            const modeValidation = response.data.validation;
                            if (modeValidation === "valid") {
                                // console.log('enviou:');

                                let obterdatareservas;
                                obterdatareservas = {
                                    hash: id,
                                }

                                //obter dados da reserva
                                axios
                                    .post(`${API_BASE_URL}/api/get_dados_reserva/`, obterdatareservas)
                                    .then(response => {
                                        const detalhesDaReserva = response.data
                                        setDataReserva(detalhesDaReserva)
                                    })
                                    .catch(error => {
                                        console.error('Erro:', error);
                                    })


                                //get todos os logs 
                                axios
                                    .get(`${API_BASE_URL}/api/get_logs/${idDaReservaPost}?timestamp=${new Date().getTime()}`)
                                    .then((response) => {
                                        const alllogsData = response.data;
                                        setLogsData(alllogsData);
                                    })
                                    .catch((error) => {
                                        console.error('Erro:', error);
                                    });


                            } else {
                                console.error('Erro:');
                            }



                            setIsAlertaFotos(false)
                            setIsLoadingFotos(false);
                            setIsSucessoFotos(true);
                            setIsFalhaFotos(false);
                            setTimeout(() => {
                                setIsAlertaFotos(false)
                                setIsLoadingFotos(false);
                                setIsSucessoFotos(false);
                                setIsFalhaFotos(false);
                            }, 1500);



                        })
                        .catch(error => {
                            console.error('Erro:', error);
                            setIsAlertaFotos(false)
                            setIsLoadingFotos(false);
                            setIsSucessoFotos(false);
                            setIsFalhaFotos(true);
                        })

            } catch (error) {
                console.error('Erro:', error);
                terminarEnvio(auditoria, error);
                setMensagemErroFotos(mensagemErroUpload(error));
                setIsAlertaFotos(false)
                setIsLoadingFotos(false);
                setIsSucessoFotos(false);
                setIsFalhaFotos(true);
            }
        };
    };

    //---------------





    //LOCAL DE ESTACIONAMENTO   ---------------

    const handleLocalEstacionamento = (e) => {
        setHistoricoLocaldeEstacionamento(e.target.value);
    };


    // Função para atualizar o histórico
    const handleAtualizarLocal = async () => {

        setlocaldeestacionamentoenviado(true)
        setIsLoadingLocalEstacionamento(true);

        if (historicolocaldeestacionamento === "" || historicolocaldeestacionamento === null) {

            setIsLoadingLocalEstacionamento(false);
            setIsSucessoLocalEstacionamentoa(false);
            setIsAlertaLocalEstacionamento(true);
            setIsFalhaLocalEstacionamento(false);
            setlocaldeestacionamentoenviado(false)

        } else {

            // const dataAtual = new Date();
            // const diaHoraAtual = dataAtual.toLocaleString('pt-PT');
            // const historicoFormatoFrase = `Funcionário: ${userNameAccount} | Data e Hora: ${diaHoraAtual} | Local: ${localdeestacionamento}`;

            // const novoHistorico = [historicoFormatoFrase, ...historicodemovimentacoesdataArray];

            try {

                let enviarlogsdata;

                enviarlogsdata = {
                    id_reserva: idDaReservaPost,
                    description: `Atualizou o Local de Estacionamento para: ${historicolocaldeestacionamento}`,
                    tipo: "local",
                    user_id: dadosdofuncionarioparalogs.ID,
                    user_name: dadosdofuncionarioparalogs.display_name,
                    update: `${historicolocaldeestacionamento}`,
                    motivo: ""
                };

                axios
                    .post(`${API_BASE_URL}/api/post_log`, enviarlogsdata)
                    .then(response => {
                        const modeValidation = response.data.validation;
                        if (modeValidation === "valid") {
                            // console.log('enviou:');

                            let obterdatareservas;
                            obterdatareservas = {
                                hash: id,
                            }

                            axios
                                .post(`${API_BASE_URL}/api/get_dados_reserva/`, obterdatareservas)
                                .then(response => {
                                    const detalhesDaReserva = response.data
                                    // console.log(detalhesDaReserva)
                                    setDataReserva(detalhesDaReserva)
                                })
                                .catch(error => {
                                    console.error('Erro:', error);
                                })


                            axios
                                .get(`${API_BASE_URL}/api/get_logs/${idDaReservaPost}?timestamp=${new Date().getTime()}`)
                                .then((response) => {
                                    // console.log(response)
                                    const alllogsData = response.data;
                                    setLogsData(alllogsData);
                                })
                                .catch((error) => {
                                    console.error('Erro:', error);
                                });

                        } else {
                            console.error('Erro:');
                        }


                        setIsLoadingLocalEstacionamento(false);
                        setIsSucessoLocalEstacionamentoa(true);
                        setIsAlertaLocalEstacionamento(false);
                        setIsFalhaLocalEstacionamento(false);
                        setlocaldeestacionamentoenviado(false)

                        setTimeout(() => {
                            setIsLoadingLocalEstacionamento(false);
                            setIsSucessoLocalEstacionamentoa(false);
                            setIsAlertaLocalEstacionamento(false);
                            setIsFalhaLocalEstacionamento(false);
                            setlocaldeestacionamentoenviado(false)
                        }, 1500);

                    })
                    .catch(error => {
                        setIsLoadingLocalEstacionamento(false);
                        setIsSucessoLocalEstacionamentoa(false);
                        setIsAlertaLocalEstacionamento(false);
                        setIsFalhaLocalEstacionamento(true);
                        setlocaldeestacionamentoenviado(false)
                        console.error('Erro:', error);
                    })


            } catch (error) {
                setIsLoadingLocalEstacionamento(false);
                setIsSucessoLocalEstacionamentoa(false);
                setIsAlertaLocalEstacionamento(false);
                setIsFalhaLocalEstacionamento(true);
                setlocaldeestacionamentoenviado(false)
                console.error('Erro:', error);
            }
        }
    };

    //---------------









    const handleFileVideoInputChange = async (e) => {
        const files = e.target.files;
        const oversized = Array.from(files).filter(f => f.size > MAX_VIDEO_SIZE_MB * 1024 * 1024);
        if (oversized.length > 0) {
            setIsAlertaVideos(true);
            setSelectedFilevideo('');
            if (inputRefVideos.current) inputRefVideos.current.value = '';
            return;
        }
        setIsAlertaVideos(false);
        setSelectedFilevideo(files);
    }

    const handleEnviarVideos = async () => {

        if (selectedFilevideo.length < 1) {
            setIsAlertaVideos(true)
            setIsLoadingVideos(false);
            setIsSucessoVideos(false);
            setIsFalhaVideos(false);

            return;

        } else {

            setIsAlertaVideos(false)
            setIsLoadingVideos(true);
            setIsSucessoVideos(false);
            setIsFalhaVideos(false);
            setMensagemErroVideos('');

            const auditoria = iniciarEnvio('videos', idDaReservaPost, selectedFilevideo);
            try {
                // Um vídeo por pedido (limite de 32MB por pedido no App Engine); o BFF junta à galeria que a reserva já tem no WP
                const videoFiles = Array.from(selectedFilevideo);
                let allVideoIds = [...conjuntodevideoids];
                for (let i = 0; i < videoFiles.length; i++) {
                    const formData = new FormData();
                    formData.append('files', videoFiles[i]);

                    const uploadResponse = await enviarLoteAuditado(auditoria, i, [videoFiles[i]], () => axios.post(
                        `/proxy-media/upload-videos/${idDaReservaPost}`,
                        formData,
                        { headers: { 'Content-Type': 'multipart/form-data', ...cabecalhosAuditoria(auditoria, i) } }
                    ));

                    allVideoIds = [...allVideoIds, ...uploadResponse.data.mediaIds];
                    setConjuntodevideoids(allVideoIds);
                    uploadResponse.data.mediaUrls.forEach(url => conjuntodevideo.push(url));
                    setConjuntodevideo([...conjuntodevideo]);
                    // O que já subiu sai da selecção, para uma nova tentativa não duplicar
                    setSelectedFilevideo(videoFiles.slice(i + 1));
                }
                setSelectedFilevideo([]);
                terminarEnvio(auditoria);

                    if (inputRefVideos.current) {
                        inputRefVideos.current.value = '';
                    }


                    let enviarlogsdata;

                    enviarlogsdata = {
                        id_reserva: idDaReservaPost,
                        description: `Adicionou vídeo/os à reserva`,
                        tipo: "upload",
                        user_id: dadosdofuncionarioparalogs.ID,
                        user_name: dadosdofuncionarioparalogs.display_name,
                    };

                    axios
                        .post(`${API_BASE_URL}/api/post_log`, enviarlogsdata)
                        .then(response => {
                            const modeValidation = response.data.validation;
                            if (modeValidation === "valid") {
                                // console.log('enviou:');

                                let obterdatareservas;
                                obterdatareservas = {
                                    hash: id,
                                }

                                axios
                                    .post(`${API_BASE_URL}/api/get_dados_reserva/`, obterdatareservas)
                                    .then(response => {
                                        const detalhesDaReserva = response.data
                                        // console.log(detalhesDaReserva)
                                        setDataReserva(detalhesDaReserva)
                                    })
                                    .catch(error => {
                                        console.error('Erro:', error);
                                    })


                                axios
                                    .get(`${API_BASE_URL}/api/get_logs/${idDaReservaPost}?timestamp=${new Date().getTime()}`)
                                    .then((response) => {
                                        // console.log(response)
                                        const alllogsData = response.data;
                                        setLogsData(alllogsData);
                                    })
                                    .catch((error) => {
                                        console.error('Erro:', error);
                                    });

                            } else {
                                console.error('Erro:');
                            }
                            setIsAlertaVideos(false)
                            setIsLoadingVideos(false);
                            setIsSucessoVideos(true);
                            setIsFalhaVideos(false);
                            setTimeout(() => {
                                setIsAlertaVideos(false)
                                setIsLoadingVideos(false);
                                setIsSucessoVideos(false);
                                setIsFalhaVideos(false);
                            }, 1500);
                        })
                        .catch(error => {
                            console.error('Erro:', error);
                            setIsAlertaVideos(false)
                            setIsLoadingVideos(false);
                            setIsSucessoVideos(false);
                            setIsFalhaVideos(true);
                        })

            } catch (error) {
                console.error('Erro:', error);
                terminarEnvio(auditoria, error);
                setMensagemErroVideos(mensagemErroUpload(error));
                setIsAlertaVideos(false)
                setIsLoadingVideos(false);
                setIsSucessoVideos(false);
                setIsFalhaVideos(true);
            }
        }



    };



    const handleEliminarFoto = (event) => {
        // alert('Eliminado');

        // console.log(event)
        const idDaImagemElimar = event

        try {
            // if (novoEstadodaReserva) {

            let enviarlogsdata;


            enviarlogsdata = {
                media_id: idDaImagemElimar,
                media_type: "fotografiascarros",
                user_id: dadosdofuncionarioparalogs.ID,
                user_name: dadosdofuncionarioparalogs.display_name,
                id_reserva: idDaReservaPost,
            }

            axios
                .post(`${API_BASE_URL}/api/delete_media_reserva`, enviarlogsdata)
                .then(response => {

                    // console.log('enviarlogsdata',enviarlogsdata)

                    const modeValidation = response.data.validation;
                    if (modeValidation === "valid") {

                        // remove image from list
                        var index_of_imgIds = conjuntodeimagensids.indexOf(idDaImagemElimar);
                        if (index_of_imgIds !== -1) {
                            conjuntodeimagensids.splice(index_of_imgIds, 1);
                        }

                        let obterdatareservas;
                        obterdatareservas = {
                            hash: id,
                        }

                        axios
                            .post(`${API_BASE_URL}/api/get_dados_reserva/`, obterdatareservas)
                            .then(response => {
                                const detalhesDaReserva = response.data
                                // console.log(detalhesDaReserva)
                                setDataReserva(detalhesDaReserva)
                            })
                            .catch(error => {
                                console.error('Erro:', error);
                            })


                        axios
                            .get(`${API_BASE_URL}/api/get_logs/${idDaReservaPost}?timestamp=${new Date().getTime()}`)
                            .then((response) => {
                                // console.log(response)
                                const alllogsData = response.data;
                                setLogsData(alllogsData);
                            })
                            .catch((error) => {
                                console.error('Erro:', error);
                            });

                    } else {
                        console.error('Erro:');
                    }

                })
                .catch(error => {
                    console.error('Erro:', error);
                })


            // } else {
            //     console.log('Erro');
            // }
        } catch (error) {
            console.error('Erro:', error);
        }
    }





    const handleEliminarVideos = (event) => {
        // alert('Eliminado');

        // console.log(event)
        const idDoVideoEliminar = event

        try {
            // if (novoEstadodaReserva) {

            let enviarlogsdata;

            enviarlogsdata = {
                media_id: idDoVideoEliminar,
                media_type: "videocarros",
                user_id: dadosdofuncionarioparalogs.ID,
                user_name: dadosdofuncionarioparalogs.display_name,
                id_reserva: idDaReservaPost,
            }

            axios
                .post(`${API_BASE_URL}/api/delete_media_reserva`, enviarlogsdata)
                .then(response => {
                    const modeValidation = response.data.validation;
                    if (modeValidation === "valid") {

                        // remove videos from list
                        setConjuntodevideoids(prev => prev.filter(videoId => videoId !== idDoVideoEliminar));

                        let obterdatareservas;
                        obterdatareservas = {
                            hash: id,
                        }

                        axios
                            .post(`${API_BASE_URL}/api/get_dados_reserva/`, obterdatareservas)
                            .then(response => {
                                const detalhesDaReserva = response.data
                                // console.log(detalhesDaReserva)
                                setDataReserva(detalhesDaReserva)
                            })
                            .catch(error => {
                                console.error('Erro:', error);
                            })


                        axios
                            .get(`${API_BASE_URL}/api/get_logs/${idDaReservaPost}?timestamp=${new Date().getTime()}`)
                            .then((response) => {
                                // console.log(response)
                                const alllogsData = response.data;
                                setLogsData(alllogsData);
                            })
                            .catch((error) => {
                                console.error('Erro:', error);
                            });

                    } else {
                        console.error('Erro:');
                    }

                })
                .catch(error => {
                    console.error('Erro:', error);
                })


            // } else {
            //     console.log('Erro');
            // }
        } catch (error) {
            console.error('Erro:', error);
        }
    }


    //LOGS ORDENAÇAO POR DATA MAIS RECENTE
    logsData.sort((a, b) => new Date(b.date) - new Date(a.date));

    // console.log('logsData', logsData)




    // console.log('fotos', fotografiassss)
    // console.log('conjuntodeimagens', conjuntodeimagens)
    // console.log('conjuntodeimagensids', conjuntodeimagensids)
    // console.log('videos', videoooos)
    // console.log('conjuntodevideo', conjuntodevideo)
    // console.log('conjuntodevideoids', conjuntodevideoids)




    return (
        <>

            {(userRole === "administrator" || userRole === "shop_manager" || userRole === "contributor") ? (
                <>
                    <Tabs defaultActiveKey="2">
                        <Tabs.TabPane tab="Estacionamento" key="1">
                            <div className="mainsec-dados-local-estacionamento">
                                {cancelamentodareserva === "Cancelado" || cancelamentodareserva === "Fechado" ? (
                                    <>
                                    </>
                                ) : (
                                    <>
                                        <br />
                                        <div className='subcol-dados-local-estacionamento custom-select'>
                                            <input
                                                type="text"
                                                className="input-calendario"
                                                onChange={handleLocalEstacionamento}
                                            />
                                            <div>
                                                <Button type="primary" htmlType="submit" className="login-form-button" onClick={handleAtualizarLocal}>
                                                    Adicionar
                                                </Button>
                                            </div>
                                        </div>
                                        <br></br>
                                        {isLoadingLocalEstacionamento ? (
                                            <LoadingMsg mensagem="Aguarde..." />
                                        ) : isAlertaLocalEstacionamento ? (
                                            <AlertaMsg mensagem="campo vazio." />
                                        ) : isFalhaLocalEstacionamento ? (
                                            <ErroMsg mensagem="tente novamente." />
                                        ) : isSucessoLocalEstacionamento ? (
                                            <SucessoMsg mensagem="local de estacionamento atualizado!" />
                                        ) : (
                                            <></>
                                        )}
                                    </>
                                )}
                                {isTabletMobile ? (
                                    <>
                                        {localdeestacionamentodata ? (
                                            <>
                                                <br></br>
                                                <div className="flex-column">
                                                    <h2>Local de Estaciomento:</h2>
                                                    <span className="label-do-campo">{localdeestacionamentodata}</span>
                                                </div>
                                            </>
                                        ) : (
                                            <p className="text-cinza">Sem registos de local de estacionamento.</p>
                                        )}
                                    </>
                                ) : (
                                    <>
                                        {localdeestacionamentodata ? (
                                            <>
                                                <br></br>
                                                <h2>Local de Estaciomento: <span className="label-do-campo">{localdeestacionamentodata}</span></h2>
                                            </>
                                        ) : (
                                            <p className="text-cinza">Sem registos de local de estacionamento.</p>
                                        )}
                                    </>
                                )}
                            </div>
                        </Tabs.TabPane >

                        <Tabs.TabPane tab="Imagens" key="2">
                            <br />
                            {cancelamentodareserva === "Cancelado" || cancelamentodareserva === "Fechado" ? (
                                <>
                                </>
                            ) : (
                                <>
                                    <div className="inserir-imagens-grupo">
                                        {isAppNativa ? (
                                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, alignItems: 'center' }}>
                                                <Button onClick={handleTirarFoto}>Tirar foto</Button>
                                                <Button onClick={handleEscolherFotosGaleria}>Escolher da galeria</Button>
                                                {selectedFile.length > 0 && <span>{selectedFile.length} foto(s) por enviar</span>}
                                            </div>
                                        ) : (
                                            <input type="file" accept="image/*" onChange={handleFileInputChange} ref={inputRef} multiple />
                                        )}
                                        <br />
                                        <Button type="primary" htmlType="submit" className="login-form-button" onClick={handleEnviarFotos} disabled={isLoadingFotos}>
                                            Adicionar
                                        </Button>

                                        {isLoadingFotos ? (
                                            <LoadingMsg mensagem="Aguarde..." />
                                        ) : isAlertaFotos ? (
                                            <AlertaMsg mensagem={`selecione uma imagem (máx. ${MAX_FILE_SIZE_MB}MB por ficheiro).`} />
                                        ) : isFalhaFotos ? (
                                            <ErroMsg mensagem={mensagemErroFotos || "tente novamente."} />
                                        ) : isSucessoFotos ? (
                                            <SucessoMsg mensagem="imagens adicionadas!" />
                                        ) : (
                                            <></>
                                        )}

                                    </div>
                                    <br />
                                    <br />
                                </>
                            )}
                            <div className="grupo-imagens-do-carro">
                                <h2>Fotografias da Viatura:</h2>
                                <hr className="linha-principal" />
                                <br />
                                <div className="imagens-do-carro">
                                    <Image.PreviewGroup>
                                        {Array.isArray(fotografiassss) && fotografiassss.length > 0 ? (
                                            fotografiassss.map((foto) => (
                                                <div className="sec-image-single" key={foto.id}>
                                                    <Image
                                                        height={200}
                                                        className="imagem-do-carro"
                                                        src={foto.url}
                                                        alt={`Imagem ${foto.id}`}
                                                        value={foto.id}
                                                    />
                                                    {userRole === "administrator" || userRole === "shop_manager" || userRole === "contributor" ? (
                                                        <a className="eliminar-imagem" value={foto.id} onClick={() => handleEliminarFoto(foto.id)}><CloseCircleOutlined /></a>
                                                    ) : null}
                                                </div>
                                            ))
                                        ) : (
                                            <p className="text-cinza">Sem registos de fotografias.</p>
                                        )}
                                    </Image.PreviewGroup>
                                </div>

                            </div>

                        </Tabs.TabPane>

                        <Tabs.TabPane tab="Vídeos" key="3">

                            <br />
                            {cancelamentodareserva === "Cancelado" || cancelamentodareserva === "Fechado" ? (
                                <>
                                </>
                            ) : (
                                <>
                                    <div className="inserir-imagens-grupo">
                                        {isAppNativa ? (
                                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, alignItems: 'center' }}>
                                                <Button onClick={handleEscolherVideosGaleria}>Escolher vídeos da galeria</Button>
                                                {selectedFilevideo.length > 0 && <span>{selectedFilevideo.length} vídeo(s) por enviar</span>}
                                            </div>
                                        ) : (
                                            <input type="file" accept="video/*" onChange={handleFileVideoInputChange} ref={inputRefVideos} multiple />
                                        )}
                                        <br />
                                        <Button type="primary" htmlType="submit" className="login-form-button" onClick={handleEnviarVideos} disabled={isLoadingVideos}>
                                            Adicionar
                                        </Button>


                                        {isLoadingVideos ? (
                                            <LoadingMsg mensagem="Aguarde..." />
                                        ) : isAlertaVideos ? (
                                            <AlertaMsg mensagem={`selecione um vídeo (máx. ${MAX_VIDEO_SIZE_MB}MB por ficheiro).`} />
                                        ) : isFalhaVideos ? (
                                            <ErroMsg mensagem={mensagemErroVideos || "tente novamente."} />
                                        ) : isSucessoVideos ? (
                                            <SucessoMsg mensagem="vídeo adicionado!" />
                                        ) : isPesodeCarregamentoVideos ? (
                                            <PesoMsg mensagem="Só consegue adicicionar vídeos com a capacidade máximo de 100MB." />
                                        ) : (
                                            <></>
                                        )}


                                    </div>
                                    <br />
                                    <br />
                                </>
                            )}

                            <div className="grupo-videos-do-carro">
                                <h2>Videos da Viatura:</h2>
                                <hr className="linha-principal" />
                                <br />
                                <div className="videos-do-carro-main">
                                    {Array.isArray(videoooos) && videoooos.length > 0 ? (
                                        videoooos.map((video) => (
                                            <>
                                                <div className="sec-image-single">
                                                    <video className="videos-do-carro" controls key={video.id}>
                                                        <source src={video.url} type="video/mp4" />
                                                    </video>
                                                    {(userRole === "administrator" || userRole === "shop_manager" || userRole === "contributor") ? (
                                                        <a className="eliminar-imagem" value={video.id} onClick={() => handleEliminarVideos(video.id)}><CloseCircleOutlined /></a>
                                                    ) : null}
                                                </div>
                                            </>
                                        ))
                                    ) : (
                                        <p className="text-cinza">Sem registos de vídeos.</p>
                                    )}
                                </div>
                            </div>
                        </Tabs.TabPane>
                        <Tabs.TabPane tab="Histórico" key="4">
                            <br />
                            <div>
                                {isTabletMobile ? (
                                    <>
                                        <Table
                                            dataSource={logsData}
                                            pagination={{
                                                pageSize: 10,
                                                position: ["bottomCenter"],
                                            }}
                                        >
                                            <Table.Column
                                                title="Nome / Data / Descrição"
                                                dataIndex="user_name"
                                                key="user_name"
                                                render={(user_name, record) => (
                                                    <>
                                                        <strong>Nome:</strong> {user_name}
                                                        <br />
                                                        <strong>Data:</strong> {record.formattedDate}
                                                        <br />
                                                        <strong>Descrição:</strong> {record.description}
                                                    </>
                                                )}
                                            />
                                        </Table>
                                    </>
                                ) : (
                                    <>
                                        <Table
                                            dataSource={logsData}
                                            pagination={{
                                                pageSize: 10,
                                                position: ["bottomCenter"],
                                            }}
                                        >
                                            <Table.Column
                                                title="Nome"
                                                dataIndex="user_name"
                                                key="user_name"
                                                render={(user_name) => (
                                                    <span>{user_name}</span>
                                                )}
                                            />
                                            <Table.Column
                                                title="Data"
                                                dataIndex="formattedDate"
                                                key="formattedDate"
                                                render={(formattedDate) => (
                                                    <span>{formattedDate}</span>
                                                )}
                                            />
                                            <Table.Column
                                                title="Descrição"
                                                dataIndex="description"
                                                key="description"
                                                render={(description) => (
                                                    <span>{description}</span>
                                                )}
                                            />
                                        </Table>

                                    </>
                                )}
                            </div>
                        </Tabs.TabPane>
                    </Tabs >

                </>
            ) : (
                <>

                    <Tabs>
                        {cancelamentodareserva === "Cancelado" || cancelamentodareserva === "Fechado" ? (
                            <>
                                <Tabs.TabPane tab="Histórico" key="1">
                                    <br />
                                    <div>
                                        {isTabletMobile ? (
                                            <>
                                                <Table
                                                    dataSource={logsData}
                                                    pagination={{
                                                        pageSize: 10,
                                                        position: ["bottomCenter"],
                                                    }}
                                                >
                                                    <Table.Column
                                                        title="Nome / Data / Descrição"
                                                        dataIndex="user_name"
                                                        key="user_name"
                                                        render={(user_name, record) => (
                                                            <>
                                                                <strong>Nome:</strong> {user_name}
                                                                <br />
                                                                <strong>Data:</strong> {record.formattedDate}
                                                                <br />
                                                                <strong>Descrição:</strong> {record.description}
                                                            </>
                                                        )}
                                                    />
                                                </Table>
                                            </>
                                        ) : (
                                            <>
                                                <Table
                                                    dataSource={logsData}
                                                    pagination={{
                                                        pageSize: 10,
                                                        position: ["bottomCenter"],
                                                    }}
                                                >
                                                    <Table.Column
                                                        title="Nome"
                                                        dataIndex="user_name"
                                                        key="user_name"
                                                        render={(user_name) => (
                                                            <span>{user_name}</span>
                                                        )}
                                                    />
                                                    <Table.Column
                                                        title="Data"
                                                        dataIndex="formattedDate"
                                                        key="formattedDate"
                                                        render={(formattedDate) => (
                                                            <span>{formattedDate}</span>
                                                        )}
                                                    />
                                                    <Table.Column
                                                        title="Descrição"
                                                        dataIndex="description"
                                                        key="description"
                                                        render={(description) => (
                                                            <span>{description}</span>
                                                        )}
                                                    />
                                                </Table>

                                            </>
                                        )}
                                    </div>
                                </Tabs.TabPane>
                            </>
                        ) : (
                            <>
                                <Tabs.TabPane tab="Estacionamento" key="1">
                                    <div className="mainsec-dados-local-estacionamento">
                                        {cancelamentodareserva === "Cancelado" || cancelamentodareserva === "Fechado" ? (
                                            <>
                                            </>
                                        ) : (
                                            <>
                                                <br />
                                                <div className='subcol-dados-local-estacionamento custom-select'>
                                                    <input
                                                        type="text"
                                                        className="input-calendario"
                                                        onChange={handleLocalEstacionamento}
                                                    />
                                                    <div>
                                                        <Button type="primary" htmlType="submit" className="login-form-button" onClick={handleAtualizarLocal}>
                                                            Adicionar
                                                        </Button>
                                                    </div>
                                                </div>
                                                <br></br>
                                                {isLoadingLocalEstacionamento ? (
                                                    <LoadingMsg mensagem="Aguarde..." />
                                                ) : isAlertaLocalEstacionamento ? (
                                                    <AlertaMsg mensagem="campo vazio." />
                                                ) : isFalhaLocalEstacionamento ? (
                                                    <ErroMsg mensagem="tente novamente." />
                                                ) : isSucessoLocalEstacionamento ? (
                                                    <SucessoMsg mensagem="local de estacionamento atualizado!" />
                                                ) : (
                                                    <></>
                                                )}
                                            </>
                                        )}
                                        {isTabletMobile ? (
                                            <>
                                                {localdeestacionamentodata ? (
                                                    <>
                                                        <br></br>
                                                        <div className="flex-column">
                                                            <h2>Local de Estaciomento:</h2>
                                                            <span className="label-do-campo">{localdeestacionamentodata}</span>
                                                        </div>
                                                    </>
                                                ) : (
                                                    <p className="text-cinza">Sem registos de local de estacionamento.</p>
                                                )}
                                            </>
                                        ) : (
                                            <>
                                                {localdeestacionamentodata ? (
                                                    <>
                                                        <br></br>
                                                        <h2>Local de Estaciomento: <span className="label-do-campo">{localdeestacionamentodata}</span></h2>
                                                    </>
                                                ) : (
                                                    <p className="text-cinza">Sem registos de local de estacionamento.</p>
                                                )}
                                            </>
                                        )}
                                    </div>
                                </Tabs.TabPane >

                                <Tabs.TabPane tab="Imagens" key="2">
                                    <br />
                                    {cancelamentodareserva === "Cancelado" || cancelamentodareserva === "Fechado" ? (
                                        <>
                                        </>
                                    ) : (
                                        <>
                                            <div className="inserir-imagens-grupo">
                                                {isAppNativa ? (
                                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, alignItems: 'center' }}>
                                                <Button onClick={handleTirarFoto}>Tirar foto</Button>
                                                <Button onClick={handleEscolherFotosGaleria}>Escolher da galeria</Button>
                                                {selectedFile.length > 0 && <span>{selectedFile.length} foto(s) por enviar</span>}
                                            </div>
                                        ) : (
                                            <input type="file" accept="image/*" onChange={handleFileInputChange} ref={inputRef} multiple />
                                        )}
                                                <br />
                                                <Button type="primary" htmlType="submit" className="login-form-button" onClick={handleEnviarFotos} disabled={isLoadingFotos}>
                                                    Adicionar
                                                </Button>

                                                {isLoadingFotos ? (
                                                    <LoadingMsg mensagem="Aguarde..." />
                                                ) : isAlertaFotos ? (
                                                    <AlertaMsg mensagem={`selecione uma imagem (máx. ${MAX_FILE_SIZE_MB}MB por ficheiro).`} />
                                                ) : isFalhaFotos ? (
                                                    <ErroMsg mensagem={mensagemErroFotos || "tente novamente."} />
                                                ) : isSucessoFotos ? (
                                                    <SucessoMsg mensagem="imagens adicionadas!" />
                                                ) : (
                                                    <></>
                                                )}

                                            </div>
                                            <br />
                                            <br />
                                        </>
                                    )}
                                    <div className="grupo-imagens-do-carro">
                                        <h2>Fotografias da Viatura:</h2>
                                        <hr className="linha-principal" />
                                        <br />
                                        <div className="imagens-do-carro">
                                            <Image.PreviewGroup>
                                                {conjuntodeimagens && conjuntodeimagens.length > 0 ? (
                                                    fotografiassss?.map((foto) => (
                                                        <>
                                                            <div className="sec-image-single">
                                                                <Image
                                                                    height={200}
                                                                    className="imagem-do-carro"
                                                                    key={foto.mediaItemId}
                                                                    src={foto.sourceUrl}
                                                                    alt={`Imagem ${foto.mediaItemId}`}
                                                                    value={foto.mediaItemId}
                                                                />

                                                                <a className="eliminar-imagem" value={foto.mediaItemId} onClick={() => handleEliminarFoto(foto.mediaItemId)}><CloseCircleOutlined /></a>
                                                            </div>
                                                        </>
                                                    ))
                                                ) : (
                                                    <p className="text-cinza">Sem registos de fotografias.</p>
                                                )}
                                            </Image.PreviewGroup>
                                        </div>
                                    </div>
                                </Tabs.TabPane>

                                <Tabs.TabPane tab="Vídeos" key="3">
                                    <br />
                                    {cancelamentodareserva === "Cancelado" || cancelamentodareserva === "Fechado" ? (
                                        <>
                                        </>
                                    ) : (
                                        <>
                                            <div className="inserir-imagens-grupo">
                                                {isAppNativa ? (
                                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, alignItems: 'center' }}>
                                                <Button onClick={handleEscolherVideosGaleria}>Escolher vídeos da galeria</Button>
                                                {selectedFilevideo.length > 0 && <span>{selectedFilevideo.length} vídeo(s) por enviar</span>}
                                            </div>
                                        ) : (
                                            <input type="file" accept="video/*" onChange={handleFileVideoInputChange} ref={inputRefVideos} multiple />
                                        )}
                                                <br />
                                                <Button type="primary" htmlType="submit" className="login-form-button" onClick={handleEnviarVideos} disabled={isLoadingVideos}>
                                                    Adicionar
                                                </Button>

                                                {isLoadingVideos ? (
                                                    <LoadingMsg mensagem="Aguarde..." />
                                                ) : isAlertaVideos ? (
                                                    <AlertaMsg mensagem={`selecione um vídeo (máx. ${MAX_VIDEO_SIZE_MB}MB por ficheiro).`} />
                                                ) : isFalhaVideos ? (
                                                    <ErroMsg mensagem={mensagemErroVideos || "tente novamente."} />
                                                ) : isSucessoVideos ? (
                                                    <SucessoMsg mensagem="vídeo adicionado!" />
                                                ) : isPesodeCarregamentoVideos ? (
                                                    <PesoMsg mensagem="Só consegue adicicionar vídeos com a capacidade máximo de 100MB." />
                                                ) : (
                                                    <></>
                                                )}


                                            </div>
                                            <br />
                                            <br />
                                        </>
                                    )}

                                    <div className="grupo-videos-do-carro">
                                        <h2>Videos da Viatura:</h2>
                                        <hr className="linha-principal" />
                                        <br />
                                        <div className="videos-do-carro-main">
                                            {conjuntodevideo && conjuntodevideo.length > 0 ? (
                                                videoooos?.map((video) => (

                                                    <>
                                                        <div className="sec-image-single">
                                                            <video className="videos-do-carro" controls key={video.mediaItemId}>
                                                                <source src={video.mediaItemUrl} type="video/mp4" />
                                                            </video>

                                                            <a className="eliminar-imagem" value={video.mediaItemId} onClick={() => handleEliminarVideos(video.mediaItemId)}><CloseCircleOutlined /></a>
                                                        </div>
                                                    </>

                                                ))
                                            ) : (
                                                <p className="text-cinza">Sem registos de vídeos.</p>
                                            )}
                                        </div>
                                    </div>
                                </Tabs.TabPane>
                                <Tabs.TabPane tab="Histórico" key="4">
                                    <br />
                                    <div>
                                        {isTabletMobile ? (
                                            <>
                                                <Table
                                                    dataSource={logsData}
                                                    pagination={{
                                                        pageSize: 10,
                                                        position: ["bottomCenter"],
                                                    }}
                                                >
                                                    <Table.Column
                                                        title="Nome / Data / Descrição"
                                                        dataIndex="user_name"
                                                        key="user_name"
                                                        render={(user_name, record) => (
                                                            <>
                                                                <strong>Nome:</strong> {user_name}
                                                                <br />
                                                                <strong>Data:</strong> {record.formattedDate}
                                                                <br />
                                                                <strong>Descrição:</strong> {record.description}
                                                            </>
                                                        )}
                                                    />
                                                </Table>
                                            </>
                                        ) : (
                                            <>
                                                <Table
                                                    dataSource={logsData}
                                                    pagination={{
                                                        pageSize: 10,
                                                        position: ["bottomCenter"],
                                                    }}
                                                >
                                                    <Table.Column
                                                        title="Nome"
                                                        dataIndex="user_name"
                                                        key="user_name"
                                                        render={(user_name) => (
                                                            <span>{user_name}</span>
                                                        )}
                                                    />
                                                    <Table.Column
                                                        title="Data"
                                                        dataIndex="formattedDate"
                                                        key="formattedDate"
                                                        render={(formattedDate) => (
                                                            <span>{formattedDate}</span>
                                                        )}
                                                    />
                                                    <Table.Column
                                                        title="Descrição"
                                                        dataIndex="description"
                                                        key="description"
                                                        render={(description) => (
                                                            <span>{description}</span>
                                                        )}
                                                    />
                                                </Table>

                                            </>
                                        )}
                                    </div>
                                </Tabs.TabPane>
                            </>
                        )}

                    </Tabs >

                </>
            )}


        </>
    );
}

export default AreaGestaoReservaAdmin;






